import { PlayerPublic } from "@aura-frontend/omnibus-az-client";

// Using this partial definition to allow the function to be used with a smaller subset of the PlayerPublic type
type IsOfficialPlayerParams = Pick<PlayerPublic, "league">;

/**
 * Checks if a player is an official player. (Comes from a verified source)
 * @param player - The player to check
 * @returns True if the player is an official player, false otherwise
 */
export const isOfficialPlayer = (player: IsOfficialPlayerParams) => {
  return player.league?.startsWith("CS") || player.league?.startsWith("PG");
};
